export enum SurveyQuestionTypes {
  CHOOSE_ONE = 'CHOOSE_ONE',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  TEXT = 'TEXT',
  RATING = 'RATING',
  BOOL = 'BOOL',
  INFO = 'INFO'
}

export interface ISurveyQuestionOption {
  id: string
  label: string
}

export const formatTextToHtml = (input) => {
  return input.replace(/(?:\r\n|\r|\n)/g, '<br />')
}

export type SurveyAnswerType = boolean | string | number | string[] | null
